<table class="ir-plugin-table">
  <tr *ngIf="config?.Label">
    <td class="plugin-table-cell">
      <span>
        <strong>{{ config.Label }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1"></span>
      </p>
    </td>
  </tr>
  <tr *ngIf="distance && distance >= 0">
    <td class="plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationdistance.distance' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ distance | distance }}</span>
      </p>
    </td>
  </tr>
</table>
